import { render } from "./studentsPage.vue?vue&type=template&id=3428e9b8&scoped=true"
import script from "./studentsPage.vue?vue&type=script&lang=js"
export * from "./studentsPage.vue?vue&type=script&lang=js"

import "./studentsPage.vue?vue&type=style&index=0&id=3428e9b8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3428e9b8"]])

export default __exports__